import "core-js/stable";
import "regenerator-runtime/runtime";
import 'isomorphic-unfetch'

import Vue from 'vue'
import TheSideMenu from './components/v1/sidemenu/TheSideMenu'
import store from './store';
import { config } from './config/config'


// Apollo
import VueApollo from 'vue-apollo'
import {apolloApiClient, apolloClient} from './config/apollo'
const apolloProvider = new VueApollo({
  clients: {
    default: apolloClient,
    apiClient: apolloApiClient
  },
  defaultClient: apolloClient,
})
Vue.use(VueApollo)
// Apollo

// moment
import moment from 'vue-moment'
Vue.use(moment)
// moment

// google analytics
import VueGtag from "vue-gtag";
Vue.use(VueGtag, {
  config: {
    id: config.google_analytics_id,
    params: {
      send_page_view: false
    }
  }
});
// google analytics

// // google analytics
// import VueGtag from "vue-gtag";
// Vue.use(VueGtag, {
//   config: { id: config.google_analytics_id },
//   params: { send_page_view: false }
// });
// // google analytics

// // vue-awesome-swiper
// // https://github.com/surmon-china/vue-awesome-swiper
// import VueAwesomeSwiper from 'vue-awesome-swiper'
// import 'swiper/css/swiper.css'
// Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
// // vue-awesome-swiper

document.addEventListener('DOMContentLoaded', () => {
  new Vue({
    el: '#side-menu',
    apolloProvider,
    store,
    // i18n: i18n,
    render: h => h(TheSideMenu, { props: document.getElementById("side-menu").dataset})
  })
})
